module.exports = __webpack_public_path__ + "static/media/branding-logo.c19fc484.png";